import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/seo';

const HomePage = () => {
    return (
        <Layout>
            <SEO title='Home'/>
            <h1 className="mt-md-6 col-xl-6 mx-xl-auto">Welcome to Gateway</h1>
            <p className="mt-md-6 pl-2 col-xl-6 mx-xl-auto">Use the search box above to find any title in our system.</p>
        </Layout>
    );
};

export default HomePage;
